/**
 * App footer — "Powered by LogBook Legal" branding shown on every authed page.
 * Single line, muted, dismissible only by the developer console (future).
 */
export default function AppFooter() {
  return (
    <footer
      className="h-10 border-t border-border bg-card text-foreground flex items-center justify-center px-4 text-xs text-muted-foreground"
      data-testid="app-footer"
    >
      <span className="flex items-center gap-2">
        <span>Powered by</span>
        <img
          src="/logbook-mark.png"
          alt="LogBook Legal"
          className="w-4 h-4 invert-on-dark inline-block align-middle"
          data-testid="footer-logbook-mark"
        />
        <span className="font-semibold">LogBook Legal</span>
      </span>
    </footer>
  );
}
